export default {"src":"/_next/static/media/switch-icon.a38cb3a7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};